var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageflag)?_c('Echart',{ref:"charts",staticClass:"left_center_inner",attrs:{"id":"leftCenter","options":_vm.options}}):_c('Reacquire',{staticStyle:{"line-height":"300px"},on:{"onclick":_vm.getData}},[_vm._v(" 重新获取 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }